import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "sh-companies",
  class: "sh-companies"
}
const _hoisted_2 = {
  key: 1,
  class: "content"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "ellipsis-cell" }
const _hoisted_5 = { class: "ellipsed" }
const _hoisted_6 = { class: "ellipsis-cell" }
const _hoisted_7 = { class: "ellipsed" }
const _hoisted_8 = { class: "ellipsis-cell" }
const _hoisted_9 = { class: "ellipsed" }
const _hoisted_10 = { class: "ellipsis-cell" }
const _hoisted_11 = { class: "ellipsed" }
const _hoisted_12 = { class: "ellipsis-cell" }
const _hoisted_13 = { class: "ellipsed" }
const _hoisted_14 = { class: "row-hvcenter" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_Badge = _resolveComponent("Badge")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_Empty = _resolveComponent("Empty")
  const _component_SearchInput = _resolveComponent("SearchInput")
  const _component_Image = _resolveComponent("Image")
  const _component_Column = _resolveComponent("Column")
  const _component_Highlight = _resolveComponent("Highlight")
  const _component_FilePicker = _resolveComponent("FilePicker")
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _component_Copy = _resolveComponent("Copy")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_AddModal = _resolveComponent("AddModal")
  const _component_EditModal = _resolveComponent("EditModal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Loading"),
            _createElementVNode("br", null, null, -1 /* HOISTED */),
            _createTextVNode(" Please wait... ")
          ])),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("header", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, " Shared Contacts ", -1 /* HOISTED */)),
            _createVNode(_component_Badge, {
              gray: "",
              style: {"width":"max-content"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($options.total), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          (!$options.total)
            ? (_openBlock(), _createBlock(_component_Empty, { key: 0 }, {
                title: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode(" There are no contacts at the moment ")
                ])),
                actions: _withCtx(() => [
                  _createVNode(_component_Button, {
                    primary: "",
                    onClick: $options.onAddContact
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        icon: "plus",
                        width: "2rem",
                        height: "2rem",
                        stroke: "var(--base-white)"
                      }),
                      _cache[3] || (_cache[3] = _createTextVNode(" Add Shared Contact "))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])
                ]),
                image: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    stroke: "var(--brand-500)",
                    width: "3rem",
                    height: "3rem",
                    icon: "building-08"
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : (_openBlock(), _createBlock(_component_DataTable, {
                key: 1,
                items: $options.view_items,
                class: "table",
                total: $options.view_total,
                skip: $data.load_params.skip,
                loading: $options.refreshing,
                "override-skip": "",
                onPage: $options.onPage
              }, {
                "header-right": _withCtx(() => [
                  _createVNode(_component_SearchInput, {
                    ref: "search",
                    disabled: $options.refreshing,
                    style: {"margin-right":"1.6rem"},
                    onSearch: $options.onSearch
                  }, null, 8 /* PROPS */, ["disabled", "onSearch"]),
                  _createVNode(_component_Button, {
                    tiny: "",
                    primary: "",
                    disabled: $options.refreshing,
                    gap: "0.6rem",
                    onClick: $options.onAddContact
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        class: "pointer",
                        icon: "plus",
                        width: "1.6rem",
                        height: "1.6rem",
                        stroke: "var(--base-white)"
                      }),
                      _cache[4] || (_cache[4] = _createTextVNode(" Add Contact "))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["disabled", "onClick"])
                ]),
                empty: _withCtx(() => [
                  _createVNode(_component_Empty, { bg: "assets/bg-pattern-square.png" }, {
                    image: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        width: "4rem",
                        height: "4rem",
                        icon: "search",
                        class: "icon-svg",
                        stroke: "var(--gray-500)"
                      })
                    ]),
                    title: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("No contacts were found")
                    ])),
                    "sub-text": _withCtx(() => [
                      _createTextVNode(" Your search “" + _toDisplayString($options.highlight) + "” did not match any contacts. ", 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "avatar",
                    class: "image-column"
                  }, {
                    header: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode(" Avatar ")
                    ])),
                    body: _withCtx(({data: {avatar_url, first_name, last_name}}) => [
                      _createVNode(_component_Image, {
                        size: "5rem",
                        name: [first_name, last_name].join(' '),
                        shape: "circle",
                        loading: $data.loading,
                        src: avatar_url
                      }, null, 8 /* PROPS */, ["name", "loading", "src"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_Column, {
                    field: "name",
                    style: {"width":"20%"}
                  }, {
                    header: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode(" Name ")
                    ])),
                    body: _withCtx(({data: {first_name, middle_name, last_name}}) => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_Highlight, {
                            text: _ctx.$utils.str.decodeHTMLEntities([first_name, middle_name, last_name].filter(Boolean).join(' ')),
                            highlight: $options.highlight
                          }, null, 8 /* PROPS */, ["text", "highlight"])
                        ])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_Column, {
                    field: "position",
                    style: {"width":"25%"}
                  }, {
                    header: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode(" Position ")
                    ])),
                    body: _withCtx(({data: {position}}) => [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_Highlight, {
                            text: _ctx.$utils.str.decodeHTMLEntities(position),
                            highlight: $options.highlight
                          }, null, 8 /* PROPS */, ["text", "highlight"])
                        ])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_Column, {
                    field: "linkedin_id",
                    style: {"width":"15%"}
                  }, {
                    header: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode(" LinkedIn ")
                    ])),
                    body: _withCtx(({data: {linkedin_id}}) => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_Highlight, {
                            text: _ctx.$utils.str.decodeHTMLEntities(linkedin_id),
                            highlight: $options.highlight
                          }, null, 8 /* PROPS */, ["text", "highlight"])
                        ])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_Column, {
                    field: "linkedin_id",
                    style: {"width":"5%"}
                  }, {
                    header: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode(" Followers ")
                    ])),
                    body: _withCtx(({data: {followers_cnt}}) => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(followers_cnt), 1 /* TEXT */)
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_Column, {
                    field: "id",
                    style: {"width":"20%"}
                  }, {
                    header: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode(" ID ")
                    ])),
                    body: _withCtx(({data: {id}}) => [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(id), 1 /* TEXT */)
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_Column, {
                    field: "created_at",
                    style: {"width":"10%"}
                  }, {
                    header: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode(" Date Added ")
                    ])),
                    body: _withCtx(({data: {created_at}}) => [
                      _createTextVNode(_toDisplayString(_ctx.$utils.format.date(created_at)), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_Column, null, {
                    body: _withCtx(({data: {id}}) => [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_FilePicker, {
                          title: "Upload avatar",
                          onUpload: $event => ($options.onUploadAvatar(id, $event))
                        }, null, 8 /* PROPS */, ["onUpload"]),
                        _createVNode(_component_IconAsButton, {
                          icon: "pencil-02",
                          onClick: $event => ($options.onEditContact(id))
                        }, null, 8 /* PROPS */, ["onClick"]),
                        _createVNode(_component_Copy, {
                          class: "pointer",
                          size: "2rem",
                          onCopy: $event => ($options.onCopyId(id))
                        }, null, 8 /* PROPS */, ["onCopy"])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["items", "total", "skip", "loading", "onPage"])),
          _createVNode(_component_AddModal, {
            ref: "addModal",
            onSubmit: $options.onNewContact
          }, null, 8 /* PROPS */, ["onSubmit"]),
          _createVNode(_component_EditModal, {
            ref: "editModal",
            onSubmit: $options.onUpdateContact
          }, null, 8 /* PROPS */, ["onSubmit"])
        ]))
  ]))
}